import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import AccountTypeCard from '../../components/AccountTypeCard';
import { CMAAlertCard } from '../../components/CMAAlertCard';
import {
  getAccountDetails,
  isAccountCMAElligible,
  hasSingleAccount,
  getCustomerNumberInfoText,
} from '../../businessLogic/AccountsBL';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { Card } from 'web-ui-components/lib/organisms/cards';

import { CommonShell } from '../../components/common/CommonShell/CommonShell';
import AlertTypesCard from '../../components/AlertTypesCard';
import { CommonModal } from '../../components/common/CommonModal';
import {
  getSavingAccounts,
  checkSweepErrorStatus,
  getSweepsAccountData,
} from '../../businessLogic/SweepsBL';
import {
  getAlertAccountData,
  getProjectionData,
  checkIsTransactionEnabled,
} from '../../businessLogic/AlertsBL';
import { getTransactionMethods } from '../../utils/TransactionMethods';
import {
  BALANCE_ALERT,
  SWEEP_ALERT,
  TRANSACTION_ALERT,
  UPPER_THRESHOLD,
  LOWER_THRESHOLD,
  ARRANGED,
  UNARRANGED,
} from '../../constants/StringConstants';
import {
  isLoading,
  isSweepEnable,
  getBrandId,
  isTransactionAlertEnable,
  isSweepAccountEnable,
  isSMEAlertEnable,
  isCAUser,
  isBalanceAlertEnabled,
} from '../../infrastructure/config/selectors';
import { updateArrangedOverdraftRequestPacket } from '../../utils/RequestPacketBuilder';

export class SingleViewAlerts extends Component {
  constructor(props) {
    super(props);
    this.onAlertTypeChange = this.onAlertTypeChange.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.updateCMA = this.updateCMA.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onPrimaryBtnClick = this.onPrimaryBtnClick.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.backClick = this.backClick.bind(this);
    this.checkIsAlertEnabled = this.checkIsAlertEnabled.bind(this);
    this.retryOverDraft = this.retryOverDraft.bind(this);
  }
  componentDidMount() {
    const {
      getCMAAlert,
      accountDetails,
      getSweepsList,
      isSweepEnable,
      isTransactionAlertEnable,
      getTransactionAlertsList,
      isSweepAccountEnable,
      getIncomingTransactionAlerts,
      isSMEAlertEnable,
      getArrangedOverdraftAlert,
      getSelectedAccountDetails,
    } = this.props;
    if (isSweepEnable && isSweepAccountEnable) {
      getSweepsList(accountDetails.id);
    }
    if (isAccountCMAElligible(accountDetails)) {
      getSelectedAccountDetails(accountDetails.id);
      getCMAAlert(accountDetails.id);
      getArrangedOverdraftAlert(accountDetails.id);
    }
    if (isTransactionAlertEnable) {
      getTransactionAlertsList(accountDetails.id);
    }
    if (isSMEAlertEnable) {
      getIncomingTransactionAlerts(accountDetails.id);
    }
  }
  // eslint-disable-next-line
  componentDidUpdate(prevProps) {
    const {
      cmaError,
      sweepError,
      transactionError,
      setSelectedSavingsAccountID,
      sweeps,
      arrangedOverdraftAlertError,
      isAccountDetailsError,
    } = this.props;
    if (
      prevProps.sweepError !== sweepError ||
      prevProps.cmaError !== cmaError ||
      prevProps.transactionError !== transactionError ||
      prevProps.arrangedOverdraftAlertError !== arrangedOverdraftAlertError ||
      prevProps.isAccountDetailsError !== isAccountDetailsError
    ) {
      if (cmaError || transactionError || sweepError) {
        this.props.routeTo('/errorpage');
      }
    }
    setSelectedSavingsAccountID(sweeps[0].other_account_id);
  }
  updateCMA() {
    const { selectedAccountId, updateCMAAlert, CMAAlert } = this.props;
    const reqData = { account_id: selectedAccountId };
    const reqBody = { enabled: !CMAAlert };
    updateCMAAlert(reqData, reqBody);
  }

  updateArrangedOverdraftAlert() {
    const { selectedAccountId, arrangedOverdraft, arrangedOverdraftAlert } = this.props;
    const reqData = { account_id: selectedAccountId };
    const reqBody = !arrangedOverdraft;
    arrangedOverdraftAlert(reqData, updateArrangedOverdraftRequestPacket(reqBody));
  }

  toggleChange(type) {
    const { CMAAlert, toggleModal, arrangedOverdraft } = this.props;
    if (!CMAAlert && type === UNARRANGED) {
      this.updateCMA();
      toggleModal(false, type);
    } else if (!arrangedOverdraft && type === ARRANGED) {
      this.updateArrangedOverdraftAlert();
      toggleModal(false, type);
    } else {
      toggleModal(true, type);
    }
  }
  handleClick() {
    this.props.toggleModal(false);
  }

  retryOverDraft(overDraftType) {
    overDraftType === UNARRANGED ? this.updateCMA() : this.updateArrangedOverdraftAlert();
  }

  onPrimaryBtnClick() {
    const { toggleModal, overDraftType } = this.props;
    toggleModal(false, overDraftType);
    overDraftType === UNARRANGED ? this.updateCMA() : this.updateArrangedOverdraftAlert();
  }

  onAlertTypeChange(alertType) {
    const { routeTo, isSMEAlertEnable } = this.props;
    switch (alertType) {
      case BALANCE_ALERT:
        routeTo('/alerts');
        break;
      case SWEEP_ALERT:
        routeTo('/sweeps');
        break;
      case TRANSACTION_ALERT:
        isSMEAlertEnable ? routeTo('/transactions') : routeTo('/outgoingtransactions');
        break;
    }
  }
  closeErrorModal() {
    const { toggleModal, closeErrorPopup } = this.props;
    toggleModal(false);
    closeErrorPopup(false);
  }

  errorModal() {
    const { updateCmaError, overDraftType, updateArrangedOverdraftAlertError } = this.props;
    return (
      <CommonModal
        isOpen={updateCmaError || updateArrangedOverdraftAlertError}
        onRequestClose={this.closeErrorModal}
        onPrimaryBtnClick={() => this.retryOverDraft(overDraftType)}
      />
    );
  }
  backClick() {
    const { userInfo, routeTo } = this.props;
    if (userInfo.accountId) {
      routeTo('/exit');
    } else {
      routeTo('/accounts');
    }
  }
  checkIsAlertEnabled() {
    const {
      highBalance,
      lowBalance,
      projectionBalance,
      wbaAlertList: { WBAAlert },
      selectedAccountId,
    } = this.props;
    let isProjectionEnabled = '';
    const accountAlerts = get(WBAAlert, ['account_alerts'], []);
    const selectedAccount = accountAlerts.find((alert) => alert.account_id === selectedAccountId);
    const isBalanceAlertEnabled = selectedAccount ? selectedAccount.enabled : false;

    if (projectionBalance) {
      isProjectionEnabled = projectionBalance.external_notifications[0].external_notification;
    }
    return (
      isBalanceAlertEnabled || highBalance.enabled || lowBalance.enabled || isProjectionEnabled
    );
  }

  // eslint-disable-next-line complexity
  render() {
    const {
      isOpen,
      CMAAlert,
      accountDetails,
      updateCmaError,
      content,
      userPhoneNumber,
      isSweepAccountEnable,
      sweeps,
      balanceError,
      isTransactionAlertEnable,
      showFooter,
      isSweepEnable,
      transactionAlerts,
      transactionAlertMethods,
      incomingTransactionAlerts,
      isCAUser,
      arrangedOverdraft,
      updateArrangedOverdraftAlertError,
      ifOverdraftAvailable,
      isAccountDetailFetched,
      isBalanceAlertEnabled,
    } = this.props;
    const {
      alertLandingPageHeader,
      alertSMELandingPageInfo,
      alertLandingPageInfo,
      alertSinglePageFooter,
      CMAModalHeader,
      CMAModalInfoCard,
      CMAModalPrimaryBtn,
      CMAModalSecondaryBtn,
    } = this.props.content;
    const checkIsAlertON = this.checkIsAlertEnabled();
    const checkIsTransactionON = checkIsTransactionEnabled(
      transactionAlerts,
      transactionAlertMethods,
      incomingTransactionAlerts
    );
    const alertLandingPageContactNumberText = isCAUser
      ? alertSMELandingPageInfo
      : alertLandingPageInfo;

    return (
      <CommonShell backClick={this.backClick}>
        <PageHeading>Manage your alerts</PageHeading>
        <TextBody>
          <p>{alertLandingPageHeader}</p>
        </TextBody>
        <Card className="u-margin-bottom-2" type="info" bordered>
          {getCustomerNumberInfoText(alertLandingPageContactNumberText, userPhoneNumber)}
        </Card>
        <AccountTypeCard accountDetails={accountDetails} />
        {isAccountDetailFetched && (
          <CMAAlertCard
            accountDetails={accountDetails}
            content={content}
            userPhoneNumber={userPhoneNumber}
            CMAAlert={CMAAlert}
            toggleChange={this.toggleChange}
            isCAUser={isCAUser}
            arrangedOverdraft={arrangedOverdraft}
            ifOverdraftAvailable={ifOverdraftAvailable}
            isAccountDetailFetched={isAccountDetailFetched}
          />
        )}
        {isBalanceAlertEnabled && !balanceError && (
          <AlertTypesCard
            typeName={BALANCE_ALERT}
            onAlertTypeChange={this.onAlertTypeChange}
            isEnabled={checkIsAlertON}
          />
        )}
        {isSweepEnable && isSweepAccountEnable && sweeps && (
          <AlertTypesCard
            typeName={SWEEP_ALERT}
            onAlertTypeChange={this.onAlertTypeChange}
            isEnabled={sweeps[0].enabled}
          />
        )}
        {isTransactionAlertEnable && (
          <AlertTypesCard
            typeName={TRANSACTION_ALERT}
            onAlertTypeChange={this.onAlertTypeChange}
            isEnabled={checkIsTransactionON}
          />
        )}
        {showFooter && (
          <TextBody>
            <p>{alertSinglePageFooter}</p>
          </TextBody>
        )}
        <CommonModal
          isOpen={isOpen}
          onRequestClose={this.handleClick}
          onPrimaryBtnClick={this.onPrimaryBtnClick}
          header={CMAModalHeader}
          infoCardContent={CMAModalInfoCard}
          primaryBtnName={CMAModalPrimaryBtn}
          secondaryBtnName={CMAModalSecondaryBtn}
        />
        {updateCmaError && this.errorModal()}
        {updateArrangedOverdraftAlertError && this.errorModal()}
      </CommonShell>
    );
  }
}

SingleViewAlerts.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.shape({
    alertLandingPageHeader: PropTypes.string,
    alertSMELandingPageInfo: PropTypes.string,
    alertLandingPageInfo: PropTypes.string,
    alertSinglePageFooter: PropTypes.string.isRequired,
    CMAModalHeader: PropTypes.string.isRequired,
    CMAModalInfoCard: PropTypes.string.isRequired,
    CMAModalPrimaryBtn: PropTypes.string.isRequired,
    CMAModalSecondaryBtn: PropTypes.string.isRequired,
  }),
  savingAccountsAvailable: PropTypes.array,
  balanceError: PropTypes.bool,
  sweeps: PropTypes.array,
  userPhoneNumber: PropTypes.array,
  bulkBalanceAlerts: PropTypes.shape({}),
  toggleModal: PropTypes.func.isRequired,
  closeErrorPopup: PropTypes.func.isRequired,
  accountData: PropTypes.array,
  CMAAlert: PropTypes.bool,
  arrangedOverdraft: PropTypes.bool,
  highBalance: PropTypes.shape({}),
  lowBalance: PropTypes.shape({}),
  getCMAAlert: PropTypes.func,
  updateSweepAlerts: PropTypes.func,
  updateCmaError: PropTypes.bool,
  updateCMAAlert: PropTypes.func,
  accountDetails: PropTypes.shape({}),
  getSweepsList: PropTypes.func,
  isSweepEnable: PropTypes.bool,
  isTransactionAlertEnable: PropTypes.bool,
  getTransactionAlertsList: PropTypes.func,
  selectedAccountId: PropTypes.string,
  routeTo: PropTypes.func,
  userInfo: PropTypes.shape({}),
  projectionBalance: PropTypes.shape({}),
  transactionAlerts: PropTypes.any,
  transactionAlertMethods: PropTypes.array,
  cmaError: PropTypes.shape({}),
  transactionError: PropTypes.bool,
  sweepError: PropTypes.bool,
  isSweepAccountEnable: PropTypes.bool,
  setSelectedSavingsAccountID: PropTypes.func,
  showFooter: PropTypes.bool,
  isSMEAlertEnable: PropTypes.bool,
  getIncomingTransactionAlerts: PropTypes.func,
  incomingTransactionAlerts: PropTypes.any,
  isCAUser: PropTypes.bool,
  arrangedOverdraftAlert: PropTypes.func,
  getArrangedOverdraftAlert: PropTypes.func,
  arrangedOverdraftAlertError: PropTypes.shape({}),
  overDraftType: PropTypes.string,
  updateArrangedOverdraftAlertError: PropTypes.bool,
  getSelectedAccountDetails: PropTypes.func,
  ifOverdraftAvailable: PropTypes.bool,
  isAccountDetailsError: PropTypes.bool,
  isAccountDetailFetched: PropTypes.bool,
  isBalanceAlertEnabled: PropTypes.bool,
  wbaAlertList: PropTypes.shape({
    WBAAlert: PropTypes.shape({
      account_alerts: PropTypes.arrayOf(
        PropTypes.shape({
          account_id: PropTypes.string,
          day_of_week: PropTypes.string,
          enabled: PropTypes.bool,
        })
      ),
    }),
  }).isRequired,
};
const mapStateToProps = (state) => {
  const accountId = state.accountList.get('selectedAccountId');
  const { accounts } = state.accountList.get('accountList');
  const sweepError = checkSweepErrorStatus(state.sweepList) || false;
  return {
    selectedAccountId: accountId,
    userInfo: state.config.get('userInfo'),
    accountDetails: getAccountDetails(accountId, accounts),
    brandID: getBrandId(state.config),
    CMAAlert: state.cmaAlert.get('cmaAlert').get('enabled'),
    getCmaError: state.cmaAlert.get('getCmaError'),
    isOpen: state.cmaAlert.get('isOpen'),
    bulkBalanceAlerts: state.bulkBalanceAlerts.get('bulkBalanceAlerts'),
    updateCmaError: state.cmaAlert.get('updateCmaError'),
    cmaError: state.cmaAlert.get('cmaError'),
    sweeps: getSweepsAccountData(sweepError, state.sweepList),
    balanceError: state.bulkBalanceAlerts.get('balanceError'),
    savingAccountsAvailable: getSavingAccounts(accounts),
    isLoading: isLoading(state.loader),
    sweepError: sweepError,
    highBalance: getAlertAccountData(state.bulkBalanceAlerts, accountId, UPPER_THRESHOLD),
    lowBalance: getAlertAccountData(state.bulkBalanceAlerts, accountId, LOWER_THRESHOLD),
    projectionBalance: getProjectionData(state.bulkProjectionAlert),
    userPhoneNumber: state.userDetails.get('userDetails').phone_numbers,
    isSweepEnable: isSweepEnable(state.accountList, state.config),
    isTransactionAlertEnable: isTransactionAlertEnable(state),
    transactionError: state.bulkTransactionAlerts.get('transactionError'),
    transactionAlerts: state.bulkTransactionAlerts.get('bulkTransactionAlerts').debit_alert,
    incomingTransactionAlerts: state.bulkTransactionAlerts.get('incomingTransactionAlerts')
      .credit_alert,
    transactionAlertMethods: getTransactionMethods(
      state.bulkTransactionAlerts.get('bulkTransactionAlerts')
    ),
    isSweepAccountEnable: isSweepAccountEnable(accountId, accounts, state.config),
    showFooter: hasSingleAccount(state.accountList.get('accountList')),
    isSMEAlertEnable: isSMEAlertEnable(state),
    isCAUser: isCAUser(state.userDetails),
    arrangedOverdraft: state.arrangedOverdraft.get('arrangedOverdraftAlert'),
    arrangedOverdraftAlertError: state.arrangedOverdraft.get('arrangedOverdraftAlertError'),
    overDraftType: state.cmaAlert.get('overDraftType'),
    updateArrangedOverdraftAlertError: state.arrangedOverdraft.get(
      'updateArrangedOverdraftAlertError'
    ),
    ifOverdraftAvailable: state.accountList.get('ifOverdraftAvailable'),
    isAccountDetailFetched: state.accountList.get('isAccountDetailFetched'),
    isAccountDetailsError: state.accountList.get('isAccountDetailsError'),
    isBalanceAlertEnabled: isBalanceAlertEnabled(accountId, accounts),
    wbaAlertList: state.WBAAlert.get('WBAAlert'),
  };
};
const mapDispatch = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatch)(SingleViewAlerts);
